import React from 'react';
import { Props as ButtonProps } from '../POSButton/POSButton';
import './AddButton.less';
import POSIconButton from '../POSIconButton';

export type Props = Omit<ButtonProps, 'icon'>;

export const AddButton = (props: Props) => {
  return <POSIconButton {...props} icon={'add'} />;
};
